import React, { useState } from 'react'
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import clsx from 'clsx';
import { PropertyTypes } from '../../../../shared/types/properties/PropertyTypes';

interface PropertiesTypeComponentProps {
    control: any,
    errors: any
}

interface OptionType {
    value: string,
    label: string
}

const PropertiesTypeComponent: React.FC<PropertiesTypeComponentProps> = ({ control, errors }) => {
    const defaultPropertyType = { value: '', label: 'All Property Types' };
    const [optionsPropertyType, _setOptionsPropertyType] = useState<OptionType[]>([
        defaultPropertyType,
        ...PropertyTypes.map((propertyType) => ({ value: propertyType.value, label: propertyType.label }))
    ]);

    return (
        <div className='form-group'>
            <label className='form-label'>Property Type</label>
            <Controller
                control={control}
                name='property_type'
                render={({ field }) => (
                    <Select
                        key={field.value}
                        {...field}
                        className={clsx('', { 'is-invalid': errors.property_type })}
                        options={optionsPropertyType}
                        value={optionsPropertyType.find((propertyType) => propertyType.value === field.value)}
                        onChange={(selectedOption) => {
                            if (selectedOption) {
                                field.onChange(selectedOption.value);
                            }
                        }}
                        defaultValue={defaultPropertyType}
                    />
                )}
            />
            {errors.property_type && <div className="invalid-feedback">{errors.property_type.message}</div>}
        </div>
    )
}

export default PropertiesTypeComponent